import MapControlPopover from '../MapControlPopover';
import type { ReactNode } from 'react';

import { POINT_MODE } from 'components/Map/constants';
import ReticleIcon from 'components/icons/ReticleIcon';
import TouchIcon from 'components/icons/TouchIcon';

import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { Props } from './types';

const PointModeDropdown = ({ onPointModeChange, pointMode, testId = TEST_ID }: Props) => {
    const { RETICLE, TOUCH } = useTranslation();

    const reticleText = (
        <>
            <ReticleIcon />

            {RETICLE}
        </>
    );
    const touchText = (
        <>
            <TouchIcon />

            {TOUCH}
        </>
    );
    const pointModeText: Record<POINT_MODE, ReactNode> = {
        [POINT_MODE.RETICLE]: reticleText,
        [POINT_MODE.TOUCH]: touchText
    };

    const options = [
        { label: RETICLE, value: POINT_MODE.RETICLE },
        { label: TOUCH, value: POINT_MODE.TOUCH }
    ];

    const pointModeIcon: Record<POINT_MODE, ReactNode> = {
        [POINT_MODE.RETICLE]: <ReticleIcon />,
        [POINT_MODE.TOUCH]: <TouchIcon />
    };

    return (
        <MapControlPopover
            displayIcon={pointModeIcon[pointMode]}
            displayText={pointModeText[pointMode]}
            onChange={onPointModeChange}
            options={options}
            testId={testId}
            value={pointMode}
        />
    );
};

export default PointModeDropdown;
